import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AlertService } from 'core/services/alert.service';
import { G2ReviewEnabledUser } from 'types';
import { EnableG2ReviewsDialogComponent } from './../enable-g2-reviews-dialog/enable-g2-reviews-dialog.component';
import { AdminG2ReviewsService } from './../../core/services/admin-g2-reviews.service';

@Component({
    selector: 'app-g2-reviews',
    templateUrl: './g2-reviews.component.html',
    styleUrls: ['./g2-reviews.component.scss']
})
export class G2ReviewsComponent implements OnInit {
    public pageSize: number = 100;
    public hasNextPage: boolean = false;
    public isLoading: boolean = false;

    public displayedColumns: string[] = ['userId', 'promptsRemaining', 'promptCount', 'lastPromptedOnUtc'];
    public dataSource: G2ReviewEnabledUser[] = [];

    private nextPageToken: string | null = null;

    public constructor(
        private adminG2ReviewsService: AdminG2ReviewsService,
        private alertService: AlertService,
        private matDialog: MatDialog
    ) {}

    public ngOnInit(): void {
        this.loadPage();
    }

    public nextPage(): void {
        this.loadPage();
    }

    public openEnableDialog(): void {
        EnableG2ReviewsDialogComponent.openDialog(this.matDialog)
            .afterClosed()
            .subscribe({
                next: (result) => {
                    if (result?.changed) this.reload();
                }
            });
    }

    private reload(): void {
        this.dataSource = [];
        this.nextPageToken = null;
        this.hasNextPage = false;
        this.loadPage();
    }

    private loadPage(): void {
        this.isLoading = true;

        this.adminG2ReviewsService
            .getEnabledUsers({ pageSize: this.pageSize, token: this.nextPageToken ?? undefined })
            .subscribe({
                next: (page) => {
                    this.isLoading = false;
                    this.nextPageToken = page.token ?? null;
                    this.hasNextPage = !!page.token;
                    this.dataSource = [...this.dataSource, ...(page.data ?? [])];
                },
                error: () => {
                    this.isLoading = false;
                    this.alertService.showErrorSnackbar('Failed to load G2 review prompt users');
                }
            });
    }
}
